module.exports = __webpack_public_path__ + "static/media/logo-savilog.1157653e.svg";